import { render, staticRenderFns } from "./NewSpec.vue?vue&type=template&id=e988c514&"
import script from "./NewSpec.vue?vue&type=script&lang=js&"
export * from "./NewSpec.vue?vue&type=script&lang=js&"
import style0 from "./NewSpec.vue?vue&type=style&index=0&id=e988c514&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports